import React, { createContext, useContext, useState } from "react";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const showSuccess = (message, subtext = "", options = {}) => {
    setAlert({ type: "success", message, subtext, options });
    setTimeout(() => setAlert(null), 3000);
  };

  const showError = (message, subtext = "", options = {}) => {
    setAlert({ type: "error", message, subtext, options });
    setTimeout(() => setAlert(null), 3000);
  };

  return (
    <AlertContext.Provider value={{ showSuccess, showError }}>
      {children}
      {alert?.type === "success" && (
        <SuccessAlert
          message={alert.message}
          subtext={alert.subtext}
          options={alert.options}
        />
      )}
      {alert?.type === "error" && (
        <ErrorAlert
          message={alert.message}
          subtext={alert.subtext}
          options={alert.options}
        />
      )}
    </AlertContext.Provider>
  );
};
